import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72d92404"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-questions-image"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.imageURL)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.imageURL,
          alt: "Imagem da questão"
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}